import { Component, Vue } from 'vue-property-decorator';
import ShippingRecordModal from '@/assets/common/Modal/ShippingRecordModal/ShippingRecordModal.vue';
import moment from "moment";
import { CsvDownload } from '@/types/APIResponse';
import {ShippingDestinationList} from "@/types/Component"
import EmptyGraphMessage from '@/assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue';
import HarvestDetailModal from '@/assets/common/Modal/HarvestDetailModal/HarvestDetailModal.vue';
import PlantingModal from '@/assets/common/Modal/PlantingModal/PlantingModal.vue';
import { LoginUser } from "@/types/Component";

@Component({
    components: {
        EmptyGraphMessage,
        ShippingRecordModal,
        HarvestDetailModal,
        PlantingModal
    }
})

export default class ShippingtList extends Vue {
    screen = 'SHIPPINGLIST';
    baseUrl = '/shipping_records_list';
    private mode = '';
    private isShow = false
    private selectedShippingId : any = ''
    private isShippingOpen = ""
    private shippingRecordDate : string | null = null
    private isRefresh = false;
    private selectedHarvestId : any = '';
    private isButtonDisabled = false;
    private showHarvestDetailModal = false;
    includeHiddenFlag = false;

    get isAdmin(): boolean {
        return this.loginUser.role.find((r: string) => {
            return r === 'ADMIN'
        }) !== undefined;
    }
    
    get loginUser(): LoginUser {
        return this.$store.getters.loginUser;
    }

    routeparams(params : any){
        this.isShippingOpen = params.query.isShippingPopup
        this.selectedShippingId = params?.query?.recordId
        this.shippingRecordDate = params?.query?.date
        if (this.isShippingOpen || this.selectedShippingId) {
            if (this.isShippingOpen === "true" && this.selectedShippingId == null) {
                this.openShippingPopUpModal(null, 'add')
            }
            else if (this.isShippingOpen === "true" && this.selectedShippingId != null) {
                this.openShippingPopUpModal(this.selectedShippingId, 'edit')
            }
        }
    }

    openShippingPopUpModal(id = null, mode = '') {
        this.selectedShippingId = id;
        this.mode = mode;
        this.isShow = true;
    } 
    closeShippingModal() {
        this.selectedShippingId = null;
        this.mode = ''
        this.isShow = false;
    }

    refreshTable () {
        this.shippingList = []
        this.totalShippedAmount = null
        this.totalShippedQuantity = null
        this.isSpinnerLoading = true
        this.getShippingList();
    }

    shippingList =  [] as any[];
    private totalShippedQuantity : string | null = null;
    private totalShippedAmount : string | null = null;
    selectScreenManagement = '/graphScreenManagement';
    selectedCropOrPlantingId : string | null = null;
    selectedPlantingOrCropName = "";
    selectedStartDate: string | Date = new Date();
    selectedEndDate: string | Date = new Date();
    startDate: string | Date = new Date();
    endDate: string | Date = new Date();
    selectedPlantingsOrCrops = 0;
    lastSetOption = false;
    plantings = [];
    crops = [];
    plantingsOrCrops = [] as any[];
    sortOrder = true;
    private isSpinnerLoading = false;
    private shippingDestinationList =[] as ShippingDestinationList[];
    private selectedShippingDestinationName = "" as any;
    private selectedDestinationId = null;
    private selectedClassification = null;
    private totalShippingAmount : string | null = null;
    private totalWeight : string | null = null;
    selectedPlantingId :string | null = null
    private isPlantingShow = false

    created() {
        this.isSpinnerLoading=true;
        const currentDate = new Date();
        this.routeparams(this.$route);
        this.selectedStartDate = moment(currentDate).startOf('month').format('YYYY-MM-DD');
        this.selectedEndDate = moment(currentDate).endOf('month').format('YYYY-MM-DD');
        this.startDate = this.selectedStartDate;
        this.endDate = this.selectedEndDate;
        this.getShippingList()
        this.getShippingDestination()
        this.getPlantings()
        this.getCrops()
    }

    getShippingList() {
        this.$apiClient.doRequest('get', `${this.baseUrl}`).then(res => {
            this.shippingList = res.recordList
            this.totalShippedAmount = res.totalShippedAmount
            this.totalShippedQuantity = res.recordList.some((r: { shippingQualityObjs: any[]; }) => r.shippingQualityObjs.some(o => o.quantityInKg === '単位未設定')) 
                ? '単位未設定' 
                : res.recordList.some((r: { shippingQualityObjs: any[]; }) => r.shippingQualityObjs.some(o => o.quantityInKg === null)) 
                ? null 
                : res.recordList.reduce((acc: any, r: { shippingQualityObjs: any[]; }) => acc + r.shippingQualityObjs.reduce((acc, o) => !o.totalFlag && o.quantityInKg !== null ? acc + (o.quantityInKg === '単位未設定' ? 0 : parseFloat(o.quantityInKg.replace(/,/g, '').replace('単位未設定', '0'))) : acc, 0), 0);
            if (res.selectedItems!=null) {
                this.plantingsOrCrops = res.selectedItems.cropId || this.lastSetOption ? this.crops : this.plantings
                this.selectedPlantingsOrCrops = res.selectedItems.cropId || this.lastSetOption ? 1 : 0;
                this.selectedCropOrPlantingId = res.selectedItems.cropId ? res.selectedItems.cropId : res.selectedItems.plantingId
                this.selectedStartDate = res.selectedItems.displayFromDate ? res.selectedItems.displayFromDate : this.selectedStartDate
                this.selectedEndDate = res.selectedItems.displayToDate ? res.selectedItems.displayToDate : this.selectedEndDate
                this.startDate = res.selectedItems.displayFromDate ? res.selectedItems.displayFromDate : this.selectedStartDate
                this.endDate = res.selectedItems.displayToDate ? res.selectedItems.displayToDate : this.selectedEndDate
                this.selectedDestinationId = res.selectedItems.shippingDestinationId
                this.selectedClassification = res.selectedItems.shippingClassification
                this.includeHiddenFlag = res.selectedItems.includeHiddenFlag
                if (this.selectedStartDate > this.selectedEndDate) {
                    this.isButtonDisabled = true;
                  }else{
                    this.isButtonDisabled = false;
                  } 
            }
            this.isSpinnerLoading = false;
        }).catch(error => {
            this.$toasted.error('データの取得に失敗しました。')
            this.shippingList = [];
            this.isSpinnerLoading = false;
        })
    }

    removeDecimalZeros(number :number) {
        let str = number.toString();
        if (str.includes('.')) {
            str = str.replace(/0+$/, ''); 
            str = str.replace(/\.$/, ''); 
        }
        return str;
    }

    getShippingDestination(){
        this.$apiClient.doRequest('get', `/admin/shipping_destinations?with_hidden=true`).then(ret => {
            this.shippingDestinationList = ret.shipping_destinations;
            this.selectedShippingDestinationName= this.shippingDestinationList.find(item=>item.id==this.selectedDestinationId)?.name
        })
    }

    getPlantings(){
        this.$apiClient.doRequest('get', '/plantings?with_hidden=true').then((res) => {
            this.plantings = res.plantings.sort((a:any,b:any) => a.name.localeCompare(b.name));
            this.plantingsOrCrops = !this.selectedPlantingsOrCrops ? this.plantings : this.crops
        })
    }

    getCrops(){
        this.$apiClient.doRequest('get', `/crops/cropBytenentId`).then(res => {
            this.crops = res.crops;
            this.crops.sort((a:any, b:any) => a.name.localeCompare(b.name));
            this.plantingsOrCrops = !this.selectedPlantingsOrCrops ? this.plantings : this.crops
            this.selectedPlantingOrCropName= this.plantingsOrCrops.find(item=>item.id==this.selectedCropOrPlantingId)?.name
        })
    }

    handlePlantingsCropSelect(){
        this.plantingsOrCrops = !this.selectedPlantingsOrCrops ? this.plantings : this.crops
        this.selectedCropOrPlantingId=null
        this.lastSetOption = this.selectedPlantingsOrCrops ? true : false;
        this.handleSelectChange();
    }

    validateDates() {
        if (!this.selectedStartDate || !this.selectedEndDate) return;
        if (this.selectedStartDate > this.selectedEndDate) {
            this.selectedStartDate = this.startDate;
            this.selectedEndDate = this.endDate;
            this.isButtonDisabled = true;
        } else {
            this.isButtonDisabled = false;
            this.startDate = this.selectedStartDate;
            this.endDate = this.selectedEndDate;
        }
    }

    handleSelectChange(flag = true) {
        this.selectedPlantingOrCropName = this.plantingsOrCrops.find(item=>item.id == this.selectedCropOrPlantingId)?.name
        const params = {
            cropId: this.selectedPlantingsOrCrops ? this.selectedCropOrPlantingId : null,
            plantingId: !this.selectedPlantingsOrCrops ? this.selectedCropOrPlantingId : null,
            startDate: this.selectedStartDate,
            endDate: this.selectedEndDate,
            destinationId:this.selectedDestinationId,
            shippingClassification: null,
            screenName: this.screen,
            includeHiddenFlag: this.includeHiddenFlag
        }
        this.$apiClient.doRequest('post', `${this.selectScreenManagement}`, params).then(res => {
            if (flag) {
                this.refreshTable();
            }
        }).catch(error => {
            this.$toasted.error('データの取得に失敗しました。')
            this.shippingList = [];
            this.isSpinnerLoading = false;
        })
    } 

    sort(fieldName: string): void {
        this.sortOrder = !this.sortOrder;
        this.shippingList.sort((a, b) => {
            const aValue = a[fieldName];
            const bValue = b[fieldName];
            if (aValue === null && bValue === null) return 0;
            if (aValue === null) return 1;
            if (bValue === null) return -1;
            if (typeof aValue === 'string' && typeof bValue === 'string') 
                return this.sortOrder ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
            if (typeof aValue === 'number' && typeof bValue === 'number') 
                return this.sortOrder ? aValue - bValue : bValue - aValue;
            return this.sortOrder ? String(aValue).localeCompare(String(bValue)) : String(bValue).localeCompare(String(aValue));
        });
    }

    sortObj(fieldName: string): void {
        this.sortOrder = !this.sortOrder;
        this.shippingList.sort((a, b) => {
            const aValue = this.getFirstPossibleValue(a, fieldName);
            const bValue = this.getFirstPossibleValue(b, fieldName);
            if (aValue === null && bValue === null) return 0;
            if (aValue === null) return 1;
            if (bValue === null) return -1;
            if (typeof aValue === 'string' && typeof bValue === 'string') 
                return this.sortOrder ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
            if (typeof aValue === 'number' && typeof bValue === 'number') 
                return this.sortOrder ? aValue - bValue : bValue - aValue;
            return this.sortOrder ? String(aValue).localeCompare(String(bValue)) : String(bValue).localeCompare(String(aValue));
        });
    }
    
    getFirstPossibleValue(obj: { [x: string]: any }, fieldName: string): any {
        const objValues = obj.shippingQualityObjs.map((obj: { [x: string]: any; }) => obj[fieldName]);
        for (const value of objValues) {
            if (value !== null && value !== undefined && value != "単位未設定") {
                return fieldName == "quantityInKg" ? parseFloat(value.replace(/,/g, '')) : value;
            }
        }
        return null;
    }    

    sortHarvestDate(): void {
        this.sortOrder = !this.sortOrder;
        this.shippingList.sort((a, b) => {
            const aValue = this.getFirstPossibleDate(JSON.parse(a.harvestRecordInfo));
            const bValue = this.getFirstPossibleDate(JSON.parse(b.harvestRecordInfo));
            if (aValue === null && bValue === null) return 0;
            if (aValue === null) return 1;
            if (bValue === null) return -1;
            if (typeof aValue === 'string' && typeof bValue === 'string') 
                return this.sortOrder ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
            if (typeof aValue === 'number' && typeof bValue === 'number') 
                return this.sortOrder ? aValue - bValue : bValue - aValue;
            return this.sortOrder ? String(aValue).localeCompare(String(bValue)) : String(bValue).localeCompare(String(aValue));
        });
    }

    getFirstPossibleDate(obj: any): any {
        if (obj === null || !Array.isArray(obj) || obj.length === 0) {
            return null;
        }
        for (const item of obj) {
            if (item && item.date) {
                return item.date;
            }
        }
        return null;
    }      

    dateNavigation(action: string) {
        if (!this.selectedStartDate || !this.selectedEndDate) return;
        this.validateDates()
        if(this.isButtonDisabled == false){
        const updateDate = (date: moment.MomentInput, offset: moment.DurationInputArg1, unit: moment.unitOfTime.Base) => moment(date).add(offset, unit).format('YYYY-MM-DD');
        const daysDifference = moment(this.selectedEndDate).diff(this.selectedStartDate, 'days')+1;
        const offset = (action === 'previous') ? -daysDifference : daysDifference;
        this.selectedStartDate = updateDate(this.selectedStartDate, offset, 'days');
        this.selectedEndDate = updateDate(this.selectedEndDate, offset, 'days');
        this.startDate = this.selectedStartDate;
        this.endDate = this.selectedEndDate;
        this.handleSelectChange();
        } else {
            this.isButtonDisabled = false
        }
    }

    private convertDate(date: Date): string {
        if (date) {
            const d = new Date(date);
            return `${d.getFullYear()}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getDate().toString().padStart(2, '0')}`;
        }
        return "-";
    }

    private minuteToHour(minute: number) {
        return minute ? Math.floor(minute / 60) + '時間' + minute % 60 + '分' : '---';
    }

    private formatNumber(input: string): string {
        const numberValue: number = parseFloat(input);
        const formattedValue: string = numberValue.toFixed(1).replace(/\.?0+$/, '');
        return formattedValue;
    }

    formatNumberInJapanese(numberToFormat: number): string {
        const japanLocale = 'ja-JP';
        const numberFormatter = new Intl.NumberFormat(japanLocale);
        const formattedNumber = numberFormatter.format(numberToFormat);
        return formattedNumber;
    }

    csvDownload() {
        this.$apiClient.getRequest(`${this.baseUrl}/csv_export?&start_date=${this.selectedStartDate}&end_date=${this.selectedEndDate}&crop_or_planting=${this.selectedPlantingOrCropName?this.selectedPlantingOrCropName:""}&classification=${this.selectedClassification?this.selectedClassification:""}`).then((res: CsvDownload) => {
            this.$apiClient.csvDownload(res)
        }).catch(error=>{
            this.$toasted.error('データの取得に失敗しました。')
        })
    }

    private processData(workersInfo: string): string[] {
        const responses: string[] = [];
        if (workersInfo == null) {
            return responses;
        }
        try {
            const workersArray = JSON.parse(workersInfo);
            if (!Array.isArray(workersArray) || workersArray.length === 0) {
                return responses;
            }
            workersArray.forEach((worker: { [key: string]: number }, index: number) => {
                const name = Object.keys(worker)[0];
                const time = this.minuteToHour(worker[name]);
                responses.push(`${name} : ${time}`);
            });
        } catch (error) {
            // Handle the error if needed
        }
        return responses;
    }

    private processToolTipLot(input: string): string[] {
        return input.split("、");
    }

    private harvestDetailProcess(id:string){
        this.selectedHarvestId = id;
        this.showHarvestDetailModal = true;

    }

    closeHarvestDetailModal() {
        this.selectedHarvestId = null;
        this.showHarvestDetailModal = false;
    }

    private sortedHarvestRecords(input: string) {
        if (!input) {
            return [];
        }
        try {
            const harvestRecords = JSON.parse(input);
            if (!Array.isArray(harvestRecords)) {
                throw new Error("Input is not an array");
            }
            return harvestRecords.sort((a: any, b: any) => {
                return new Date(a.date).getTime() - new Date(b.date).getTime();
            });
        } catch (error) {
            return [];
        }
    }
    
    openPlantingModal(id = null) {
        this.selectedPlantingId = id;
        this.isPlantingShow = true;
    }

    closePlantingModal() {
        this.selectedPlantingId = null;
        this.isPlantingShow = false;
    }

    formLabel(arr: any[], key: string): string {
        let result = '';
        arr.forEach(item => {
            if (item[key] !== undefined) {
                let val = "";
                if (key === "quantity" || key === "unitPrice" || key === "amount") {
                    val = this.formatDigit(item[key]);
                } else if (key === "quantityInKg") {
                    val = item[key] == "単位未設定" ? `<span style="color: red;" class="tooltip">単位未設定</span>` : item[key];
                } else {
                    val = this.formString(item[key], key);
                }
                if (key == "quantity") {
                    if (item["weightUnitName"] != null) {
                        val += item["weightUnitName"];
                    } else {
                        val = '---';
                    }
                }
                result += `${item['totalFlag'] ? `(${val || '---'})` : val || '---'}\n`;
            } else {
                result += '\n';
            }
        });
        return result;
    }

    formString(str: string, key: string): string {
        if (str === null) {
            return "---";
        }
        const length = key == "qualityStandardName" ? 10 : 5;
        return str.length > length ? str.substring(0, length-3) + "..." : str;
    }

    formatDigit(numberToFormat?: number): string {
        return typeof numberToFormat === 'number' ? 
        numberToFormat.toLocaleString(undefined, {
            minimumFractionDigits: 0, 
            maximumFractionDigits: (numberToFormat % 1 !== 0) ? 2 : 0
        }) 
        : '';
    }

    get filterShippingDestinationList() {
        return this.includeHiddenFlag ? this.shippingDestinationList : this.shippingDestinationList.filter(s => this.selectedDestinationId == s.id || !s.is_hidden);
    }      

    get filterPlantingsOrCrops() {
        if (this.selectedPlantingsOrCrops) {
            return this.plantingsOrCrops
        } else {
            return this.includeHiddenFlag ? this.plantingsOrCrops : this.plantingsOrCrops.filter(p => this.selectedCropOrPlantingId == p.id || !p.is_hidden);
        }
    }
}